/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Close from "../../../Helpers/CloseBtn/Close";
import { popupcontext } from "../../../../context/Popupscontext";
import { useMap } from "react-leaflet";
import trans from "../../../../utils";

export default function GeofenceHead() {
  let { handleClose, isEditing } = useContext(popupcontext);
  const map = useMap();
  return (
    <div className="flex-between p-16">
      <div className="d-flex align-items-center w-50">
        <img
          src={`${process.env.PUBLIC_URL}/assets/Geofence.svg`}
          alt="Geofence"
        />
        <div className="fs-16 fw-600 text-capitalize mx-2">
          {!isEditing ? trans("add new geofence") : trans("edit geofence")}
        </div>
      </div>
      <Close
        style="close close-btn"
        img="Close"
        close={() => {
          handleClose("editing");
          map.dragging.enable();
        }}
      />
    </div>
  );
}
